/**
 * Filter-option builders for the lander + offer pickers. Each shapes a
 * catalog response into the {value,label} list a SearchableSelect expects,
 * with a "All …" sentinel as the first entry.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type {
  BinomAffiliateNetwork,
  BinomCountry,
  BinomGroup,
  BinomLanguage,
} from '@/hooks/binom';

export interface PickerFilterOption {
  value: string;
  label: string;
}

export function groupFilterOptions(
  data: BinomGroup[] | undefined,
): PickerFilterOption[] {
  const list = Array.isArray(data) ? data : [];
  return [
    { value: '', label: 'All groups' },
    ...list.map((g) => ({ value: g.uuid, label: g.name })),
  ];
}

export function languageFilterOptions(
  data: BinomLanguage[] | undefined,
): PickerFilterOption[] {
  const list = Array.isArray(data) ? data : [];
  return [
    { value: '', label: 'All languages' },
    ...list.map((l) => ({ value: l.code, label: `${l.name} (${l.code})` })),
  ];
}

export function countryFilterOptions(
  data: BinomCountry[] | undefined,
): PickerFilterOption[] {
  const list = Array.isArray(data) ? data : [];
  return [
    { value: '', label: 'All geo' },
    ...list.map((c) => ({ value: c.code, label: `${c.name} (${c.code})` })),
  ];
}

export function networkFilterOptions(
  data: BinomAffiliateNetwork[] | undefined,
): PickerFilterOption[] {
  const list = Array.isArray(data) ? data : [];
  return [
    { value: '', label: 'All networks' },
    ...list.map((n) => ({ value: String(n.id), label: n.name })),
  ];
}

export function groupNameMap(
  data: BinomGroup[] | undefined,
): Map<string, string> {
  const list = Array.isArray(data) ? data : [];
  return new Map(list.map((g) => [g.uuid, g.name]));
}
